import React from 'react';
import { FILTER_IDENTIFIERS } from '../../../common/constants/constants';
import { ENTITY_CONSTANTS, ENTITY_REFERENCE_LABEL } from '../../../common/constants/entityConstants';
import { FORM_WIDGET_COMPONENTS, METADATA_NAMES } from '../../../common/form/formConstants';
import { FormContainer } from '../../../common/form/FormContainer';
import FormItem from '../../../common/form/FormItem';
import FormWidget from '../../../common/form/FormWidget';
import I18n from '../../../common/i18n/I18n';
import { Production_Field_Names } from '../../helpers/productionUtils';
import ProductionPersonOptionRendered, { getProductionPersonOption } from './ProductionPersonOptionRendered';

type CreateProductionTrackSectionType = {
    onCreateHandle: (e) => void;
    hidden?: boolean;
    disabledFields?: Record<string, boolean>;
    focusField?: string;
};

export default ({
    onCreateHandle,
    hidden = false,
    disabledFields = {},
    focusField
}: CreateProductionTrackSectionType) => {
    return (
        <FormContainer titleI18nToken={'production.form.title.track'} hidden={hidden}>
            <FormItem half>
                <FormWidget
                    component={FORM_WIDGET_COMPONENTS.entityAutocomplete}
                    entity={ENTITY_CONSTANTS.person}
                    name="projectOwnerContacts"
                    label={<I18n token="production.form.field.owner" />}
                    addOption
                    OptionRenderer={(val) => <ProductionPersonOptionRendered option={val?.option} />}
                    getOption={getProductionPersonOption}
                    onCreateHandle={onCreateHandle}
                    preload={false}
                    multiple
                    entityReferenceKey={ENTITY_REFERENCE_LABEL.personReference}
                />
            </FormItem>
            <FormItem half hidden={hidden}>
                <FormWidget
                    component="MetadataAutocomplete"
                    metadataName={METADATA_NAMES.productionProjectStatus}
                    name={Production_Field_Names.projectStatus}
                    label={<I18n token="production.form.field.project.status" />}
                    allowCreate
                    disabled={disabledFields[Production_Field_Names.projectStatus]}
                />
            </FormItem>
            <FormItem half>
                <FormWidget
                    component={FORM_WIDGET_COMPONENTS.metadataAutocomplete}
                    metadataName={METADATA_NAMES.documentTag}
                    identifier={FILTER_IDENTIFIERS.termset}
                    multiple
                    allowCreate
                    name="tags"
                    label={<I18n token="common.label.tags" />}
                    autoFocus={focusField === Production_Field_Names.tags}
                />
            </FormItem>
        </FormContainer>
    );
};
